import React, { Component, createRef } from "react";
import { StyleSheet, View, TextInput, Text, TouchableOpacity, Platform } from "react-native";
import { connect } from "react-redux";
import NewIssue from "../dialogs/newIssue";
import { searchInventoryTypes } from "../../actions/records";
import Swal from "sweetalert2";
import colors from "../../constants/colors";
import DropDown from "../widgets/dropdownMultiple";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { sortSearch } from "../../utils";
import { isMobileWeb, getNoAutofillProps, noAutofillRef } from "../../utils/mobileWeb";
class SearchInventory extends Component {
    constructor(props) {
        super(props);
        this._interval = null;
        this.state = {
            // value: ((props.defaultLabel == "lotcode_finished" || props.defaultLabel == "lotcode_wip") && props.isShipmentLog) ? "" : props.initial ? props.initial : "",
            value: typeof props.initial == "string" ? props.initial : "",
            height: 30,
            items: [],
            wasEdited: false,
            options: props.options ? props.options : [],
            lotsSelected: (props.defaultLabel == "lotcode_finished" || props.defaultLabel == "lotcode_wip" || props.defaultLabel == "lotcode") && props.isShipmentLog && props.initial ? props.initial : [],
            openList: false,
            focused: false
        };
        this.textInputRef = createRef(null);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isShipmentLog, defaultLabel, position } = this.props;
        if (nextProps.initial != this.props.initial) {
            if ((defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip" || defaultLabel == "lotcode") && isShipmentLog) {
                this.setState({ lotsSelected: nextProps.initial });
            } else
                this.setState({ value: nextProps.initial });
        }
        if (nextProps.options != this.props.options) {
            this.setState({ options: nextProps.options });
        }
        if (nextProps.reset != this.props.reset) {
            if ((defaultLabel == "lotcode_finished" || defaultLabel == "lotcode_wip" || defaultLabel == "lotcode") && isShipmentLog) {
                this.setState({ lotsSelected: nextProps.initial });
            } else
                this.setState({ value: nextProps.initial });
        }
        if (nextProps.closeSearch != this.props.closeSearch && !this.textInputRef.current?.isFocused()) {
            this.setState({ items: [], wasEdited: false });
            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
        }
    }
    componentWillUnmount() {
        if (this._interval) clearInterval(this._interval);
        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
    }
    searchItems(val, focused) {
        const { type, searchBy, isShipmentLog, showWipSearch, onSelectItem, options, resetDropDown } = this.props;
        const { openList } = this.state;
        if(this._interval)clearInterval(this._interval);
        if (val || focused) {
            if (searchBy == 'lot') {
                if (isShipmentLog) {
                    if (options) {
                        var filtered = options.filter((option) => {
                            if (option?.lot) {
                                return option.lot.toLowerCase().includes(val.toLowerCase());
                            }
                        });
                        this.setState({ options: filtered, openList: filtered?.length <= 0 ? false : true }, () => {
                            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(filtered?.length > 0);
                            if (filtered?.length <= 0) {
                                if(!focused)onSelectItem(val, null);
                            }
                        });
                    }
                } else {
                    var data = { page: 1, lot: val, type, fromApp: true, fromRecipe: true };
                    if (showWipSearch) {
                        data.name = showWipSearch;
                        data.showWipSearch = true;
                    }
                    this.props.searchInventoryTypes(data, (res) => {
                        const nextItems = res?.inventoryTypes || [];
                        this.setState({ items: nextItems });
                        if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(nextItems.length > 0);
                    });
                }
            } else {
                this.props.searchInventoryTypes({ page: 1, name: val, type, fromApp: true }, (res) => {
                    const ordered = res?.inventoryTypes.slice().sort((a, b) => sortSearch(a, b, val));
                    this.setState({ items: ordered });
                    if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(ordered.length > 0);
                    if(resetDropDown)resetDropDown();
                });
            }

        } else {
            this.setState({ items: [], options: this.props.options });
            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
        }
    }
    alert() {
        Swal.fire({
            text: "This item was already selected, please choose another one",
            confirmButtonText: "Ok",
            confirmButtonColor: colors.orange,
            backdrop: false
        });
    }
    onSelectedItemsChange(lotsSelected) {
        const { onSelectItem, initial } = this.props;
        this.setState({ lotsSelected });
        if (typeof initial == "string") {
            this.setState({ value: "" });
        }
        onSelectItem(lotsSelected, null);
    }
    validLots(lots) {
        const { id, position, submission } = this.props;
        var lotsSelecteds = submission[id];
        var valid = true;
        if (lots?.length > 0 && typeof lots == "object") {
            lots.map((lotCode) => {
                if (lotsSelecteds) {
                    lotsSelecteds.map((lotselected, idx) => {
                        if (idx != position && lotselected) {
                            lotselected.map((lS) => {
                                if (lS?.lot == lotCode?.lot) {
                                    valid = false;
                                }
                            })
                        }
                    })
                }
            });
        }
        return valid;
    }
    alertConfirm(msg, conf) {
        Swal.fire({
            text: msg,
            confirmButtonText: conf,
            confirmButtonColor: '#0B4DA0',
            backdrop: false
        });
    }
    render() {
        const { value, items, wasEdited, lotsSelected, options, openList, focused } = this.state;
        const { defaultComponent, onSelectItem, searchBy, itemInvoice_id, submission, position, isShipmentLog, isInventoryTransfer, width, openDropDown, backgroundColor, isLast, isDropDownOpened, resetDropDown, isInventoryReceivingForm, inventoryTableDesign, setShowTextBar } = this.props;
        const inventoryTableCellDesign = !!(isInventoryReceivingForm || inventoryTableDesign);
        const transferSearchPill = !!(isInventoryTransfer && inventoryTableDesign);
        const transferPillHasData = !!(value && String(value).trim());
        return <View>
            <TextInput
                {...getNoAutofillProps()}
                value={value}
                ref={noAutofillRef(this.textInputRef)}
                editable={!defaultComponent}
                onContentSizeChange={(event) => {
                    if (event.nativeEvent.contentSize.height == 0) {
                        if (this.props.placeholder == '') {
                            this.setState({ height: 30 })
                        }
                        this.setState({ height: event.nativeEvent.contentSize.height });
                    } else {
                        setTimeout(() => {
                            this.setState({ height: event.nativeEvent.contentSize.height });
                        }, 5)
                    }
                }}
                onFocus={()=>{
                    this.setState({ focused: !focused })
                    if(!defaultComponent && !value){
                        if(this._interval)clearInterval(this._interval);
                        this._interval = setInterval(() => this.searchItems(value ? value : "" , true), 500);
                        //this.searchItems(value ? value : "" , true);
                    }
                    /* Same as iqops2: clear KeyboardBar when focus moves to a non-lot search field */
                    if (setShowTextBar && (isMobileWeb() || Platform.OS === "android")) {
                        setShowTextBar(null, null, null, null, null, null, null, false);
                    }
                }}
                style={{...styles.input,
                    borderColor: transferSearchPill
                      ? (transferPillHasData ? colors.orange : colors.primary)
                      : "#e7e7e7",
                    borderRadius: transferSearchPill ? 20 : 5,
                    borderWidth: transferSearchPill
                      ? (transferPillHasData ? 1.5 : 0)
                      : (inventoryTableCellDesign ? 0 : 1),
                    color: transferSearchPill
                      ? (transferPillHasData ? "#222" : "#fff")
                      : "#424242",
                    backgroundColor: transferSearchPill
                      ? (transferPillHasData ? "#fff" : colors.primary)
                      : "transparent",
                    fontFamily: "Roboto",
                    fontSize: transferSearchPill ? 14 : (inventoryTableCellDesign ? 16 : 20),
                    fontWeight: "400",
                    padding: transferSearchPill ? 8 : 5,
                    height: transferSearchPill ? 36 : this.state.height,
                    fontStyle: transferSearchPill && !value ? 'normal' : (this.state.value ? this.state.value.length == 0 ? 'italic' : 'normal' : 'normal'),
                    overflow: 'hidden',
                    textAlign: transferSearchPill || inventoryTableCellDesign ? 'center' : 'left',
                }}
                multiline={!transferSearchPill}
                placeholder={transferSearchPill ? "Search" : (searchBy == 'lot' ? "Enter a lot to search" : "Enter an item to search")}
                placeholderTextColor={transferSearchPill ? (transferPillHasData ? "#222" : "#fff") : 'rgb(0, 47, 108)'}
                onChangeText={(val) => {
                    if (val == '' && this.props.placeholder == '') {
                        this.setState({ value: val, height: 30, wasEdited: true });
                    } else {
                        this.setState({ value: val, wasEdited: true });
                    }
                    if(this._interval)clearInterval(this._interval);
                    this._interval = setInterval(() => this.searchItems(val, false), 500);
                }}
            />
            {
                isShipmentLog && searchBy == 'lot' && options?.length > 0 ?
                    <DropDown
                        //initialOption={ typeof options.find(x => x.lot == this.state.lot) === 'undefined'  ? options[0] : {lotsSelected: lotsSelected }}
                        initialOption={lotsSelected}
                        updated={lotsSelected}
                        reset={this.props.reset}
                        options={options}
                        openList={openList}
                        defaultComponent={defaultComponent}
                        defaultLabel={"No Lot"}
                        allLabel={"FIFO"}
                        allValue={["default_lot"]}
                        onSelect={(lots) => {
                            this.onSelectedItemsChange(lots);
                        }}
                        openDropDown={openDropDown}
                        backgroundColor={backgroundColor}
                        isLast={isLast}
                        isDropDownOpened={isDropDownOpened}
                        resetDropDown={resetDropDown} 
                    />
                    : null
            }
            {
                items?.length > 0 &&
                items.map((item, idx) => {
                    return <TouchableOpacity key={idx} style={{ ...styles.row, gridTemplateColumns: width == "mini" ? "80% 20%" : isInventoryReceivingForm ? "82% 18%" : "90% 10%" }} onPress={() => {
                            if (searchBy == 'lot') {
                                onSelectItem(item, null);
                            } else {
                                if (submission[itemInvoice_id]) {
                                    var exists = submission[itemInvoice_id].filter(sub => sub == item?.lot);
                                    if (exists.length > 0 && submission[itemInvoice_id][position] != item?.lot) {
                                        this.alert();
                                        return;
                                    }
                                }
                                var newItem = item;
                                newItem.lotSelected = ["default_lot"];
                                if (isInventoryTransfer) {
                                    onSelectItem(item?.item ? item.item : "", item);
                                } else if (isShipmentLog) {
                                    var newItem = item;
                                    //newItem.lotSelected = ["default_lot"];
                                    onSelectItem(item?.item, newItem);
                                } else {
                                    onSelectItem(item, item);
                                }
                            }
                            this.setState({ items: [], value: searchBy == 'lot' ? item?.lot : item?.item, wasEdited: false });
                            if (this.props.setTableSearchOpen) this.props.setTableSearchOpen(false);
                        }}
                    >
                        <div style={styles.itemTxt}>
                            {searchBy == 'lot' ? item?.lot : item?.item}
                        </div>
                        <div>
                            <div style={styles.rowBtn}><Text>
                                    <MaterialCommunityIcons name="plus" style={styles.selectOption} />
                                </Text>
                            </div>
                        </div>

                    </TouchableOpacity>
                })
            }
            {
                ((value && items?.length <= 0 && wasEdited) && ((!isShipmentLog && searchBy != 'lot') || (isShipmentLog && searchBy != 'lot'))) ? <View>
                    <Text>No items were found</Text>
                </View> : null
            }

        </View>
    }
}

export default connect((state, ownProps = {}) => ({
    isLoading: state.forms.getIn(["form", "status"]) === "loading",
}), (dispatch, props) => ({
    searchInventoryTypes: (formid, saveAsTemplate, saveAsForm, callback) =>
        dispatch(searchInventoryTypes(formid, saveAsTemplate, saveAsForm, callback)),
}))(SearchInventory);

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        paddingTop: 5,
        flex: 1,
    },
    input: {
        borderColor: "#e7e7e7",
        borderRadius: 5,
        borderWidth: 1,
        color: "#424242",
        fontFamily: "Roboto",
        fontSize: 22,
        fontWeight: "400",
        paddingLeft: 10,
    },
    label: {
        fontSize: 20,
        color: '#939598',
        fontWeight: '300',
        fontFamily: 'Roboto',

    },
    row: {
        display: "grid",
        //padding: 5,
        width: "100%",
        gridTemplateColumns: "90% 10%",
        fontFamily: "Roboto",
        fontSize: 18
    },
    rowBtn: {
        color: colors.selectSearch,
        border: '2px solid',
        borderRadius: 4,
        cursor: 'pointer'
    },
    selectOption: { 
        fontSize: 20, 
        color: colors.selectSearch 
    },
    itemTxt: {
        wordBreak: 'word-break',
        padding: 3
    }
});